'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const moment=require('pulsar-utils/dist-es6/time/moment');
const BaseService=require('../../../dist-es6/client/angularCommon/baseService');let

DateService=function(_BaseService){_inherits(DateService,_BaseService);
function DateService(){_classCallCheck(this,DateService);var _this=_possibleConstructorReturn(this,
_BaseService.call(this));

_this.reset();return _this;
}DateService.prototype.

reset=function reset(){
this._now=function(){return new Date};
this._isMocked=!1;
};DateService.prototype.

setMockDate=function setMockDate(date){
this._now=function(){return new Date(date)};
this._isMocked=!0;
};DateService.prototype.





now=function now(){
return this._now();
};DateService.prototype.

currentDateString=function currentDateString(){
return this.getLocalDateStringFor(this.now());
};DateService.prototype.

getLocalDateStringFor=function getLocalDateStringFor(date){
return moment.utc(date).local().format(`YYYY-MM-DD`);
};_createClass(DateService,[{key:'isMocked',get:function(){return this._isMocked}}]);return DateService}(BaseService);


module.exports=DateService;
//# sourceMappingURL=dateService.js.map
